// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".veraAdContainer_WTLKu{padding:0}@media only screen and (min-width:768px){.veraAdContainer_WTLKu{padding:10px 50px}}.veraTitle_JGOVl{font-size:28px;font-weight:700}.veraBodyText_pifWa{padding-top:8px;padding-bottom:20px;text-align:center}.veraImgAndTitle_\\+p4hQ{display:flex;align-items:center;justify-content:center}.veraImgAndTitle_\\+p4hQ img{width:80px;margin-right:5px}", ""]);
// Exports
exports.locals = {
	"veraAdContainer": "veraAdContainer_WTLKu",
	"veraTitle": "veraTitle_JGOVl",
	"veraBodyText": "veraBodyText_pifWa",
	"veraImgAndTitle": "veraImgAndTitle_+p4hQ"
};
module.exports = exports;
